var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.98 87.3101L85.96 90.2901L91.92 84.3301",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6699 4.8999L88.3299 10.5699",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6699 16.2398L88.3299 10.5698",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8 10.5698H93.05",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52002 89.6101C7.52002 92.8301 13.63 92.7101 13.63 89.6101C13.63 87.8201 11.73 87.4201 10.57 87.4201C9.41004 87.4201 7.51001 87.0201 7.51001 85.2301C7.51001 82.1301 13.62 82.0101 13.62 85.2301",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 91.9299V94.3899",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 80.45V82.92",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71997 7.17993H15.42",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71997 10.5698H15.42",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71997 13.96H15.42",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.14 1H1V20.14H20.14V1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.14 77.8501H1V96.9901H20.14V77.8501Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9999 77.8501H77.8599V96.9901H96.9999V77.8501Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9999 1H77.8599V20.14H96.9999V1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3099 7.25H45.6799V13.88H52.3099V7.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3099 84.1101H45.6799V90.7401H52.3099V84.1101Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9999 72.3399C61.8902 72.3399 72.3399 61.8902 72.3399 48.9999C72.3399 36.1096 61.8902 25.6599 48.9999 25.6599C36.1096 25.6599 25.6599 36.1096 25.6599 48.9999C25.6599 61.8902 36.1096 72.3399 48.9999 72.3399Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6301 36.7701C42.2301 34.7801 45.4701 33.5901 49.0001 33.5901C57.5101 33.5901 64.4001 40.4901 64.4001 48.9901C64.4001 57.4901 57.5001 64.3901 49.0001 64.3901C40.5001 64.3901 33.6001 57.4901 33.6001 48.9901",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.55 48.9999C59.55 54.8299 54.82 59.55 49 59.55C43.18 59.55 38.45 54.8199 38.45 48.9999C38.45 43.1799 43.18 38.45 49 38.45",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 46.42C45.14 43.5 48.66 42.29 51.57 43.71C54.49 45.13 55.7 48.65 54.28 51.56C52.86 54.47 49.34 55.69 46.43 54.27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 43.73H23.2099",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.48 43.73H18.63",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1301 43.5898C16.5701 43.6798 17.0201 43.7198 17.4801 43.7198",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.74 40.6599C12.24 41.4099 12.89 42.0599 13.65 42.5699",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 36.8198C10.5701 37.2798 10.62 37.7298 10.7 38.1698",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 35.5V36.82",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 30.2V32.8499",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 24.9099V27.5599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 20.95V22.27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 54.27H23.2099",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.48 54.27H18.63",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1301 54.4C16.5701 54.31 17.0201 54.27 17.4801 54.27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.74 57.3399C12.24 56.5899 12.89 55.9399 13.65 55.4299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 61.1798C10.5701 60.7198 10.62 60.2698 10.7 59.8298",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 62.4999V61.1799",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 67.7899V65.1399",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 73.0799V70.4299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 77.05V75.72",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.08 43.73H74.79",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5201 43.73H79.3701",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.87 43.5898C81.43 43.6798 80.98 43.7198 80.52 43.7198",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2601 40.6599C85.7601 41.4099 85.1101 42.0599 84.3501 42.5699",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4301 36.8198C87.4301 37.2798 87.38 37.7298 87.3 38.1698",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 35.5V36.82",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 30.2V32.8499",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 24.9099V27.5599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 20.95V22.27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M77.08 54.27H74.79",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5201 54.27H79.3701",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.87 54.4C81.43 54.31 80.98 54.27 80.52 54.27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2601 57.3399C85.7601 56.5899 85.1101 55.9399 84.3501 55.4299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4301 61.1798C87.4301 60.7198 87.38 60.2698 87.3 59.8298",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 62.4999V61.1799",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 67.7899V65.1399",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 73.0799V70.4299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4302 77.05V75.72",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19.1299V22.1399",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M49 14.6299V16.1299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78.8599V75.8599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83.3698V81.8599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.a3ee3a479054ba632b4be06ce6ab436b.svg";
export { ForwardRef as ReactComponent };